// Renders plain text, turning any web address into a real clickable link.
const URL_RE = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
const isUrl = (p) => /^(https?:\/\/|www\.)/i.test(p);

export function Linkify({ text }) {
  const str = text == null ? "" : String(text);
  const parts = str.split(URL_RE);
  return (
    <>
      {parts.map((part, i) =>
        isUrl(part) ? (
          <a
            key={i}
            href={part.startsWith("http") ? part : `https://${part}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-olive underline break-words"
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </a>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </>
  );
}
